import { useEffect, useRef, useState } from 'react';
import { isCargoExpired, isCargoRunning } from '../utils/negotiationStatus';

// One server-aligned clock for the whole detail page. `clockOffsetMs`
// (serverNow - client now, taken per fetch) keeps every cargo timer on BE
// time. It ticks only while a cargo is running, and calls `onExpire` once per
// cargo deadline so the page can refetch and pick up OVERDUE from the BE.
const useNegotiationClock = (detail, onExpire) => {
  const offset = detail?.clockOffsetMs || 0;
  const cargoes = detail?.cargoes;
  const running = (cargoes || []).some(isCargoRunning);
  const [nowMs, setNowMs] = useState(() => Date.now() + offset);
  const fired = useRef(new Set());

  useEffect(() => {
    setNowMs(Date.now() + offset);
    if (!running) return undefined;
    const id = setInterval(() => setNowMs(Date.now() + offset), 1000);
    return () => clearInterval(id);
  }, [offset, running]);

  useEffect(() => {
    const expired = (cargoes || []).filter(
      c =>
        isCargoExpired(c, nowMs) && !fired.current.has(`${c.id}|${c.deadline}`)
    );
    if (!expired.length) return;
    expired.forEach(c => fired.current.add(`${c.id}|${c.deadline}`));
    onExpire?.();
  }, [cargoes, nowMs, onExpire]);

  return nowMs;
};

export default useNegotiationClock;
